<template>
    <van-popup
        v-model="popupFreight"
        position="right"
        :duration='0'
        :overlay='false'
        :close-on-click-overlay='true'
    >
        <div class="popup">
            <FreightList :freightInfoData='freightData' v-if="freightData" @getFreightBack='getFreightBack' />
        </div>
    </van-popup>
</template>

<script>
import FreightList from '../freightDetails'
export default {
    components: {
        FreightList
    },
    data () {
        return {
            // freightData: null
        }
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        freightInfo: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
        popupFreight: {
            get () {
                return this.visible
            },
            set () {
                this.$emit('update:visible')
            }
        },
        freightData () {
            let freightArr = this.freightInfo.skuFreightDetailList.map(item => {
                return {
                    productName: item.skuName,
                    productPictureUrl: item.skuImageUrl,
                    quantity: item.quantity,
                    finalTotalAmount: item.totalFreight,
                    singleFreight: item.singleFreight,
                    price: item.price
                }
            })
            return {
                finalTotalAmount: this.freightInfo.freight, /// / 实际运费金额
                skus: freightArr,
                discountAmount: this.freightInfo.discountAmount, // 运费优惠金额
                totalAmount: this.freightInfo.totalAmount // 运费合计金额
            }
        }
    },
    methods: {
        getFreightBack (item) {
            this.$emit('update:visible')
        }
    },
    mounted () {
    }
}
</script>

<style lang="scss" scoped>
.popup {
    background: #ffffff;
    height: 100%;
    position: relative;
}
</style>